<template>
  <div class="main">
    <h1 class="title">{{ title }}</h1>
    <p>Click the Login button in the above menu.</p>
    <p>Please allow pop-ups for the Login screen.</p>
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {
    title: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
